export const locations = {
  home: '/',
  rooms: '/rooms',
  room: (id) => `/rooms/${id}`,
  contacts: '/contacts',
  activities: '/activities',
  book: '/book',
}
